import React, { useRef, useState, forwardRef, useImperativeHandle} from "react";
import {AnimatePresence, motion} from "framer-motion";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SubmitCommentButton from "../SubmitCommentButton";
import PresetModal from "../../UI/Modal/PresetModal/PresetModal";
import Auth from "../../../containers/Auth/Auth";
import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";

const AddPatternComment = forwardRef(({token, pattern_id, userId, update = () => {}, alwaysShow = false, startingText = '', hideButton = false, rows = 4}, ref) => {
    const [comment, setComment] = useState(startingText);
    const [showInput, setShowInput] = useState(alwaysShow);
    const [plusIsHovered, setPlusIsHovered] = useState(false);
    const loginModal = useRef();
    const submitRef = useRef();
    const appearAndExit = {
        open: {
            height: 'auto', opacity: 1, transition: {
                duration: .5, ease: "easeInOut"
            },
        }, closed: {
            height: 0, opacity: 0, transition: {
                duration: .5, ease: "easeInOut"
            },
        },
    };

    const getComment = () => {return comment}

    useImperativeHandle(ref, () => ({
        sendComment: () => {
            submitRef.current && submitRef.current.submit();
        },
        getComment: getComment
    }))

    const buttonStyles = {
        marginTop: 10, marginBottom: 10, marginRight: 10, float: "right",
        borderColor: !showInput && alwaysShow && 'gray',
        backgroundColor: !showInput && alwaysShow && 'gray',
    }

    const disable = !showInput && alwaysShow;

    return (
        <>
            {!alwaysShow && <div
                style={{display: "flex", alignItems: "center", justifyContent: "space-between", margin: "0 auto 10px"}}>
                <h3 style={{fontSize: "16px", fontWeight: "bold",}}>
                    Add a Comment:
                </h3>
                <AddCircleOutlineIcon
                    size="sm"
                    onMouseEnter={() => setPlusIsHovered(true)}
                    onMouseLeave={() => setPlusIsHovered(false)}
                    style={{
                        color: plusIsHovered ? "#00bd00" : "green",
                        transform: plusIsHovered ? 'scale(1.2)' : 'scale(1)',
                        marginRight: "calc(2%)"
                    }}
                    onClick={() => {
                        if (token) {
                            setShowInput(prevState => !prevState)
                        } else {
                            loginModal.current.open();
                        }
                    }}
                />
            </div>}
            <AnimatePresence>
                {(showInput || alwaysShow) &&
                    <motion.div
                        variants={appearAndExit}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        style={{overflow: "hidden"}}
                    >
                        <div className="comment-form">
                            <TextAreaWithTabs
                                rows={rows}
                                placeholder={"Enter your comment here"}
                                value={comment}
                                onChange={(event) => setComment(event.target.value)}
                            />
                        </div>
                        <SubmitCommentButton
                            ref={submitRef}
                            update={update}
                            onSubmit={() => setShowInput(false)}
                            userId={userId}
                            pattern_id={pattern_id}
                            token={token}
                            resetComment={() => {
                                    setComment("");
                                    setShowInput(false);
                                }}
                            getComment={getComment()}
                            buttonStyle={buttonStyles}
                            buttonText={"Submit Comment"}
                            disable={disable}
                            hideButton={hideButton}
                        />
                    </motion.div>
                }
            </AnimatePresence>
            <PresetModal ref={loginModal} title={"Login to Leave a Comment"}><Auth shouldRedirect hideDragon/></PresetModal>
        </>);

})

export default AddPatternComment;